import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';
import { faBox, faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-day-transfers-from-branch',
  templateUrl: './day-transfers-from-branch.component.html',
  styleUrl: './day-transfers-from-branch.component.scss',
  standalone: false,
})
export class DayTransfersFromBranchComponent implements OnChanges {


  readonly faBox = faBox;
  readonly faChevronRight = faChevronRight;

  @Input() selectedDate: any;
  @Input() selectedBranch: any;

  totalEntries: number = 0;
  totalAmount: number = 0;
  transferFromBranchList: any[] = [];
  loader: boolean = false;
  errMsg: string = "";

  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly cmsService: CommonServiceService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.totalEntries = 0;
      this.totalAmount = 0;
      this.transferFromBranchList = [];
      this.getData();
    }
  }


  getData() {
    this.loader = true;
    this.errMsg = '';
    let params: any = {
      created_date: this.selectedDate
    }
    if (this.selectedBranch) {
      params.company = this.selectedBranch
    }
    this.dayBookService.getTransfersFromBranch(params).subscribe({
      next: (res: any) => {
        this.loader = false
        this.mapResponse(res.data || [])
      },
      error: (err: any) => {
        this.loader = false;
        this.errMsg = err.error.error.message || "Failed to fetch response"
      }
    })
  }

  mapResponse(data: any) {
    if (!data || data?.length == 0) this.errMsg = "No data found"
    if (!Array.isArray(data)) return;
    let tableData = data.map((item: any) => {
      return {
        ...item,
        quantity: this.cmsService.parseNumberOrNull(item.quantity)
      };
    });
    this.transferFromBranchList = tableData;
  }

  viewAllReturns(modalContent: any) {
    this.modalService.open(modalContent, { size: 'lg', centered: true, scrollable: true });
  }

}
